import axios from "../axios";

export const getStudentInfo = async(value, id) => {
   
   const {data} = await axios.get(`students/${value}/${id}`)
  
   return data
}